import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Utilities_ShellService } from './Utilities.shell.service';
import { Utilities_OperationService } from './Utilities.operation.service';
import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Utilities_FlowService } from './Utilities.flow.index';
import { Utilities_ReportService } from './Utilities.report.index';
import { Utilities_LocalizationService } from './Utilities.localization.service';
import { Utilities_logs_grid_ComponentContextService } from './Utilities.logs_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Utilities.frontend.types'
import { $frontendTypes as $types} from './Utilities.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Utilities_processes_dd_singleComponent } from './Utilities.processes_dd_single.component'


interface IUtilities_logs_gridComponentEntity {
  log_id?: string, application_name?: string, process_name?: string, transaction_id?: string, level?: number, notes?: string, message?: string, created_by?: string, created_on?: string, alerted_on?: string, number_1?: number, number_2?: number, number_3?: number, number_4?: number, number_5?: number, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string, date_number?: number}

interface IUtilities_logs_gridComponentInParams {
  application_name?: string, transaction_id?: string, grid_title?: string, column_names?: { number_1?: string, number_2?: string, number_3?: string, number_4?: string, number_5?: string, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string }, filter_values?: { number_1?: number, number_2?: number, number_3?: number, number_4?: number, number_5?: number, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string }}


class Utilities_logs_gridComponentRowModel extends GridRowModel {
  grid: Utilities_logs_gridComponent;
  entity: IUtilities_logs_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    json_test_display: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    xml_test_display: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  override cells = {
    id: null,
    application_name: null,
    process_name: null,
    transaction_id: null,
    level: null,
    notes: null,
    message: null,
    created_by: null,
    created_on: null,
    alerted_on: null,
    number_1: null,
    number_2: null,
    number_3: null,
    number_4: null,
    number_5: null,
    string_1: null,
    string_2: null,
    string_3: null,
    string_4: null,
    string_5: null,
    json_test: null,
    xml_test: null,
  }



  constructor(
    grid: Utilities_logs_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Utilities_ShellService,
private $datasources: Utilities_DatasourceService,
private $flows: Utilities_FlowService,
private $reports: Utilities_ReportService,
private $localization: Utilities_LocalizationService,
private $operations: Utilities_OperationService,
private $logger: CleanupLoggerService,
private $context: Utilities_logs_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.application_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.application_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.process_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.process_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.transaction_id = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.transaction_id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.level = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.level,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.notes = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.message = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.message,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_by = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_by,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_on = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_on,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.alerted_on = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.alerted_on,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.number_1 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.number_1,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.number_2 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.number_2,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.number_3 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.number_3,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.number_4 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.number_4,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.number_5 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.number_5,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.string_1 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.string_1,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.string_2 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.string_2,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.string_3 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.string_3,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.string_4 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.string_4,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.string_5 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.string_5,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.json_test = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.json_test,
       new CodeBoxModel(this.formGroup.controls['json_test_display'] as DatexFormControl, null, null, false, 'json', null)
,
null
      );
    
    this.cells.xml_test = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.xml_test,
       new CodeBoxModel(this.formGroup.controls['xml_test_display'] as DatexFormControl, null, null, false, 'xml', null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IUtilities_logs_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.log_id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IUtilities_logs_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.log_id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.log_id;
    const inParams = {
      $keys:[$resultKey],
      application_name:  $grid.inParams.application_name ,
      date_from:  $grid.filters.date_from.control.value ,
      date_to:  $grid.filters.date_to.control.value ,
      full_text_search:  $grid.fullTextSearch ,
      level:  $grid.filters.level.control.value ,
      process_name:  $grid.filters.process.control.value ,
      transaction_id:  $grid.inParams.transaction_id ,
      string_1:  $grid.inParams.filter_values?.string_1 ,
      string_2:  $grid.inParams.filter_values?.string_2 ,
      string_3:  $grid.inParams.filter_values?.string_3 ,
      string_4:  $grid.inParams.filter_values?.string_4 ,
      string_5:  $grid.inParams.filter_values?.string_5 ,
      number_1:  $grid.inParams.filter_values?.number_1 ,
      number_2:  $grid.inParams.filter_values?.number_2 ,
      number_3:  $grid.inParams.filter_values?.number_3 ,
      number_4:  $grid.inParams.filter_values?.number_4 ,
      number_5:  $grid.inParams.filter_values?.number_5 ,
    };
    const data = await this.$datasources.Utilities.ds_logs_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IUtilities_logs_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.id.displayControl as TextModel).text = $row.entity.log_id;
    (this.cells.application_name.displayControl as TextModel).text = $row.entity.application_name;
    (this.cells.process_name.displayControl as TextModel).text = $row.entity.process_name;
    (this.cells.transaction_id.displayControl as TextModel).text = $row.entity.transaction_id;
    (this.cells.level.displayControl as TextModel).text = $row.entity.level?.toString();
    (this.cells.notes.displayControl as TextModel).text = $row.entity.notes;
    (this.cells.message.displayControl as TextModel).text = $row.entity.message;
    (this.cells.created_by.displayControl as TextModel).text = $row.entity.created_by;
    (this.cells.created_on.displayControl as TextModel).text = $row.entity.created_on?.toString();
    (this.cells.alerted_on.displayControl as TextModel).text = $row.entity.alerted_on?.toString();
    (this.cells.number_1.displayControl as TextModel).text = $row.entity.number_1?.toString();
    (this.cells.number_2.displayControl as TextModel).text = $row.entity.number_2?.toString();
    (this.cells.number_3.displayControl as TextModel).text = $row.entity.number_3?.toString();
    (this.cells.number_4.displayControl as TextModel).text = $row.entity.number_4?.toString();
    (this.cells.number_5.displayControl as TextModel).text = $row.entity.number_5?.toString();
    (this.cells.string_1.displayControl as TextModel).text = $row.entity.string_1;
    (this.cells.string_2.displayControl as TextModel).text = $row.entity.string_2;
    (this.cells.string_3.displayControl as TextModel).text = $row.entity.string_3;
    (this.cells.string_4.displayControl as TextModel).text = $row.entity.string_4;
    (this.cells.string_5.displayControl as TextModel).text = $row.entity.string_5;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'transaction_id' : {
        this.on_transaction_clicked();
        break;
      }
      case 'notes' : {
        this.on_notes_clicked();
        break;
      }
      case 'message' : {
        this.on_message_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_notes_clicked(event = null) {
    return this.on_notes_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_notes_clickedInternal(
    $row: Utilities_logs_gridComponentRowModel,
  $grid: Utilities_logs_gridComponent, 
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 02/04/2025
  
  let is_json: boolean = false;
  let is_xml: boolean = false;
  
  let payload_string: string = $row.entity.notes;
  
  if ($utils.isDefined(payload_string)) {
      payload_string = payload_string.trim();
  
      try {
          $row.cells.json_test.displayControl.value = payload_string;
          if ($utils.isDefined($row.cells.json_test.displayControl.value)) {
              is_json = true;
          }
      } catch (e) { }
  
      try {
          if (payload_string.includes("<") && payload_string.includes(">")) {
              $row.cells.xml_test.displayControl.value = payload_string;
              if ($utils.isDefined($row.cells.xml_test.displayControl.value)) {
                  is_xml = true;
              }
          }
      } catch (e) { }
  
      if (is_json) {
          await $shell.Utilities.openview_json_payloadDialog({
              payload: payload_string,
              title: "Notes",
              id: $row.entity.log_id,
              application_name: $row.entity.application_name,
              storage: "Log"
          }, "modal", EModalSize.Xlarge);
      } else if (is_xml) {
          await $shell.Utilities.openview_xml_payloadDialog({
              payload: payload_string,
              title: "Notes",
              id: $row.entity.log_id,
              application_name: $row.entity.application_name,
              storage: "Log"
          }, "modal", EModalSize.Xlarge);
      } else {
          $shell.Utilities.openInfoDialog("Notes", payload_string);
      }
  }
  }
  on_message_clicked(event = null) {
    return this.on_message_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_message_clickedInternal(
    $row: Utilities_logs_gridComponentRowModel,
  $grid: Utilities_logs_gridComponent, 
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 02/04/2025
  
  let is_json: boolean = false;
  let is_xml: boolean = false;
  
  let payload_string: string = $row.entity.message;
  
  if ($utils.isDefined(payload_string)) {
      payload_string = payload_string.trim();
  
      try {
          $row.cells.json_test.displayControl.value = payload_string;
          if ($utils.isDefined($row.cells.json_test.displayControl.value)) {
              is_json = true;
          }
      } catch (e) { }
  
      try {
          if (payload_string.includes("<") && payload_string.includes(">")) {
              $row.cells.xml_test.displayControl.value = payload_string;
              if ($utils.isDefined($row.cells.xml_test.displayControl.value)) {
                  is_xml = true;
              }
          }
      } catch (e) { }
  
      if (is_json) {
          await $shell.Utilities.openview_json_payloadDialog({
              payload: payload_string,
              title: "Message",
              id: $row.entity.log_id,
              application_name: $row.entity.application_name,
              storage: "Log"
          }, "modal", EModalSize.Xlarge);
      } else if (is_xml) {
          await $shell.Utilities.openview_xml_payloadDialog({
              payload: payload_string,
              title: "Message",
              id: $row.entity.log_id,
              application_name: $row.entity.application_name,
              storage: "Log"
          }, "modal", EModalSize.Xlarge);
      } else {
          $shell.Utilities.openInfoDialog("Notes", payload_string);
      }
  }
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: Utilities_logs_gridComponentRowModel,
  $grid: Utilities_logs_gridComponent, 
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  const format = `MM/DD/YYYY, LT`;
  
  if ($utils.isDefined(format)) {
      if ($utils.isDefined($row.entity.created_on)) {
          $row.cells.created_on.displayControl.text = $utils.date.format($row.entity.created_on, format);
      };
      if ($utils.isDefined($row.entity.alerted_on)) {
          $row.cells.alerted_on.displayControl.text = $utils.date.format($row.entity.alerted_on, format);
      };
  };
  
  let notes = $row.entity.notes;
  
  if ($utils.isDefined(notes)) {
      notes = (notes.length > 75) ? notes.substring(0, 75) : notes;
      $row.cells.notes.displayControl.text = notes;
  };
  
  let message = $row.entity.message;
  
  if ($utils.isDefined(message)) {
      message = (message.length > 75) ? message.substring(0, 75) : message;
      $row.cells.message.displayControl.text = message;
  };
  }
  on_transaction_clicked(event = null) {
    return this.on_transaction_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_transaction_clickedInternal(
    $row: Utilities_logs_gridComponentRowModel,
  $grid: Utilities_logs_gridComponent, 
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  if (!$utils.isDefined($grid.inParams.transaction_id)) {
  
      let transaction_id: string = $row.entity.transaction_id;
  
      if ($utils.isDefined(transaction_id)) {
          if (transaction_id !== "") {
              $shell.Utilities.opentransaction_hubDialog({ column_names: $grid.inParams.column_names, transaction_id: transaction_id, activate_grid: "logs" }, "modal", EModalSize.Xlarge);
          }
      }
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Utilities_processes_dd_singleComponent),
  ],
  selector: 'Utilities-logs_grid',
  templateUrl: './Utilities.logs_grid.component.html'
})
export class Utilities_logs_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IUtilities_logs_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IUtilities_logs_gridComponentInParams = { application_name: null, transaction_id: null, grid_title: null, column_names: { number_1: null, number_2: null, number_3: null, number_4: null, number_5: null, string_1: null, string_2: null, string_3: null, string_4: null, string_5: null }, filter_values: { number_1: null, number_2: null, number_3: null, number_4: null, number_5: null, string_1: null, string_2: null, string_3: null, string_4: null, string_5: null } };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     id: new GridHeaderModel(new HeaderStyles(null, null), 'id', 'Id', false, false, null, false),       application_name: new GridHeaderModel(new HeaderStyles(null, null), 'application_name', 'Application', false, false, null, false),       process_name: new GridHeaderModel(new HeaderStyles(null, null), 'process_name', 'Process', false, false, null, false),       transaction_id: new GridHeaderModel(new HeaderStyles(null, null), 'transaction_id', 'Transaction', false, false, null, false),       level: new GridHeaderModel(new HeaderStyles(null, null), 'level', 'Level', false, false, null, false),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'notes', 'Notes', false, false, null, false),       message: new GridHeaderModel(new HeaderStyles(null, null), 'message', 'Message', false, false, null, false),       created_by: new GridHeaderModel(new HeaderStyles(null, null), 'created_by', 'Created by', false, false, null, false),       created_on: new GridHeaderModel(new HeaderStyles(null, null), 'created_on', 'Created on', false, false, null, false),       alerted_on: new GridHeaderModel(new HeaderStyles(null, null), 'alerted_on', 'Alerted on', false, false, null, false),       number_1: new GridHeaderModel(new HeaderStyles(null, null), 'number_1', 'Number 1', false, false, null, false),       number_2: new GridHeaderModel(new HeaderStyles(null, null), 'number_2', 'Number 2', false, false, null, false),       number_3: new GridHeaderModel(new HeaderStyles(null, null), 'number_3', 'Number 3', false, false, null, false),       number_4: new GridHeaderModel(new HeaderStyles(null, null), 'number_4', 'Number 4', false, false, null, false),       number_5: new GridHeaderModel(new HeaderStyles(null, null), 'number_5', 'Number 5', false, false, null, false),       string_1: new GridHeaderModel(new HeaderStyles(null, null), 'string_1', 'String 1', false, false, null, false),       string_2: new GridHeaderModel(new HeaderStyles(null, null), 'string_2', 'String 2', false, false, null, false),       string_3: new GridHeaderModel(new HeaderStyles(null, null), 'string_3', 'String 3', false, false, null, false),       string_4: new GridHeaderModel(new HeaderStyles(null, null), 'string_4', 'String 4', false, false, null, false),       string_5: new GridHeaderModel(new HeaderStyles(null, null), 'string_5', 'String 5', false, false, null, false),       json_test: new GridHeaderModel(new HeaderStyles(null, null), 'json_test', 'Json test', false, false, null, false),       xml_test: new GridHeaderModel(new HeaderStyles(null, null), 'xml_test', 'Xml test', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: Utilities_logs_gridComponentRowModel[] = [];

  @Input('application_name') set $inParams_application_name(value: any) {
    this.inParams['application_name'] = value;
  }
  get $inParams_application_name(): any {
    return this.inParams['application_name'] ;
  }
  @Input('transaction_id') set $inParams_transaction_id(value: any) {
    this.inParams['transaction_id'] = value;
  }
  get $inParams_transaction_id(): any {
    return this.inParams['transaction_id'] ;
  }
  @Input('grid_title') set $inParams_grid_title(value: any) {
    this.inParams['grid_title'] = value;
  }
  get $inParams_grid_title(): any {
    return this.inParams['grid_title'] ;
  }
  @Input('column_names') set $inParams_column_names(value: any) {
    this.inParams['column_names'] = value;
  }
  get $inParams_column_names(): any {
    return this.inParams['column_names'] ;
  }
  @Input('filter_values') set $inParams_filter_values(value: any) {
    this.inParams['filter_values'] = value;
  }
  get $inParams_filter_values(): any {
    return this.inParams['filter_values'] ;
  }

  topToolbar = {
      clean_log: new ToolModel(new ButtonModel('clean_log', new ButtonStyles(null, null), false, false, false, 'Clean', 'icon-ic_fluent_recycle_20_regular', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      delete_log: new ToolModel(new ButtonModel('delete_log', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    level: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    process: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    level: new FieldModel(new NumberBoxModel(this.formGroup.controls['level'] as DatexFormControl, null, false, false, '', '', null)
, new ControlContainerStyles(null, null), 'Level', false, false),
    process: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['process'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Process', false, false),
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, false, '', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date from', false, false),
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, false, '', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date to', false, false),
  }

  //#region filters inParams
  get $fields_process_selector_inParams_application_name(): string {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.application_name;
    
    return expr;
  }

  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Utilities_ShellService,
    private $datasources: Utilities_DatasourceService,
    private $flows: Utilities_FlowService,
    private $reports: Utilities_ReportService,
    private $localization: Utilities_LocalizationService,
    private $operations: Utilities_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Utilities_logs_grid_ComponentContextService,
    ) {
    super();
    this.title = 'logs_grid';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      application_name:  $grid.inParams.application_name ,
      date_from:  $grid.filters.date_from.control.value ,
      date_to:  $grid.filters.date_to.control.value ,
      full_text_search:  $grid.fullTextSearch ,
      level:  $grid.filters.level.control.value ,
      process_name:  $grid.filters.process.control.value ,
      transaction_id:  $grid.inParams.transaction_id ,
      string_1:  $grid.inParams.filter_values?.string_1 ,
      string_2:  $grid.inParams.filter_values?.string_2 ,
      string_3:  $grid.inParams.filter_values?.string_3 ,
      string_4:  $grid.inParams.filter_values?.string_4 ,
      string_5:  $grid.inParams.filter_values?.string_5 ,
      number_1:  $grid.inParams.filter_values?.number_1 ,
      number_2:  $grid.inParams.filter_values?.number_2 ,
      number_3:  $grid.inParams.filter_values?.number_3 ,
      number_4:  $grid.inParams.filter_values?.number_4 ,
      number_5:  $grid.inParams.filter_values?.number_5 ,
    };
    try {
      const data = await this.$datasources.Utilities.ds_logs_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IUtilities_logs_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new Utilities_logs_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: Utilities_logs_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: Utilities_logs_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  $grid.title = 'Logs'
  $grid.headers.id.hidden = true;
  $grid.headers.xml_test.hidden = true;
  $grid.headers.json_test.hidden = true;
  $grid.topToolbar.delete_log.control.readOnly = true;
  
  let grid_title: string = $grid.inParams.grid_title ?? "";
  let application_name: string = $grid.inParams.application_name ?? "";
  
  if (application_name.toUpperCase() === "NULL") {
      application_name = "";
  }
  
  if (application_name !== "") {
      $grid.headers.application_name.hidden = true;
  }
  
  if (grid_title !== "") {
      $grid.title = grid_title
  }
  
  if ($utils.isDefined($grid.inParams.column_names)) {
  
      let column_names = $grid.inParams.column_names;
  
      if ($utils.isDefined(column_names.number_1)) { $grid.headers.number_1.name = column_names.number_1 }
      if ($utils.isDefined(column_names.number_2)) { $grid.headers.number_2.name = column_names.number_2 }
      if ($utils.isDefined(column_names.number_3)) { $grid.headers.number_3.name = column_names.number_3 }
      if ($utils.isDefined(column_names.number_4)) { $grid.headers.number_4.name = column_names.number_4 }
      if ($utils.isDefined(column_names.number_5)) { $grid.headers.number_5.name = column_names.number_5 }
      if ($utils.isDefined(column_names.string_1)) { $grid.headers.string_1.name = column_names.string_1 }
      if ($utils.isDefined(column_names.string_2)) { $grid.headers.string_2.name = column_names.string_2 }
      if ($utils.isDefined(column_names.string_3)) { $grid.headers.string_3.name = column_names.string_3 }
      if ($utils.isDefined(column_names.string_4)) { $grid.headers.string_4.name = column_names.string_4 }
      if ($utils.isDefined(column_names.string_5)) { $grid.headers.string_5.name = column_names.string_5 }
  }
  
  //{ "number_1": "Numeric one", "number_2": "Numeric two", "number_3": "Numeric three", "number_4": "Numeric four", "number_5": "Numeric five", "string_1": "Transaction id", "string_2": "Egress id", "string_3": "Text three", "string_4": "Text four", "string_5": "Text five" }
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: Utilities_logs_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/24/2024
  
  if ($utils.isDefined($grid.rows)) {
  
      let process_name = $grid.rows.filter(r => $utils.isDefined(r.entity.process_name))?.map(r => r.entity.process_name); if ($utils.isDefined(process_name)) { $grid.headers.process_name.hidden = false } else { $grid.headers.process_name.hidden = true }
      let transaction_id = $grid.rows.filter(r => $utils.isDefined(r.entity.transaction_id))?.map(r => r.entity.transaction_id); if ($utils.isDefined(transaction_id)) { $grid.headers.transaction_id.hidden = false } else { $grid.headers.transaction_id.hidden = true }
      let level = $grid.rows.filter(r => $utils.isDefined(r.entity.level))?.map(r => r.entity.level); if ($utils.isDefined(level)) { $grid.headers.level.hidden = false } else { $grid.headers.level.hidden = true }
      let notes = $grid.rows.filter(r => $utils.isDefined(r.entity.notes))?.map(r => r.entity.notes); if ($utils.isDefined(notes)) { $grid.headers.notes.hidden = false } else { $grid.headers.notes.hidden = true }
      let message = $grid.rows.filter(r => $utils.isDefined(r.entity.message))?.map(r => r.entity.message); if ($utils.isDefined(message)) { $grid.headers.message.hidden = false } else { $grid.headers.message.hidden = true }
      let created_by = $grid.rows.filter(r => $utils.isDefined(r.entity.created_by))?.map(r => r.entity.created_by); if ($utils.isDefined(created_by)) { $grid.headers.created_by.hidden = false } else { $grid.headers.created_by.hidden = true }
      let created_on = $grid.rows.filter(r => $utils.isDefined(r.entity.created_on))?.map(r => r.entity.created_on); if ($utils.isDefined(created_on)) { $grid.headers.created_on.hidden = false } else { $grid.headers.created_on.hidden = true }
      let alerted_on = $grid.rows.filter(r => $utils.isDefined(r.entity.alerted_on))?.map(r => r.entity.alerted_on); if ($utils.isDefined(alerted_on)) { $grid.headers.alerted_on.hidden = false } else { $grid.headers.alerted_on.hidden = true }
      let number_1 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_1))?.map(r => r.entity.number_1); if ($utils.isDefined(number_1)) { $grid.headers.number_1.hidden = false } else { $grid.headers.number_1.hidden = true }
      let number_2 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_2))?.map(r => r.entity.number_2); if ($utils.isDefined(number_2)) { $grid.headers.number_2.hidden = false } else { $grid.headers.number_2.hidden = true }
      let number_3 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_3))?.map(r => r.entity.number_3); if ($utils.isDefined(number_3)) { $grid.headers.number_3.hidden = false } else { $grid.headers.number_3.hidden = true }
      let number_4 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_4))?.map(r => r.entity.number_4); if ($utils.isDefined(number_4)) { $grid.headers.number_4.hidden = false } else { $grid.headers.number_4.hidden = true }
      let number_5 = $grid.rows.filter(r => $utils.isDefined(r.entity.number_5))?.map(r => r.entity.number_5); if ($utils.isDefined(number_5)) { $grid.headers.number_5.hidden = false } else { $grid.headers.number_5.hidden = true }
      let string_1 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_1))?.map(r => r.entity.string_1); if ($utils.isDefined(string_1)) { $grid.headers.string_1.hidden = false } else { $grid.headers.string_1.hidden = true }
      let string_2 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_2))?.map(r => r.entity.string_2); if ($utils.isDefined(string_2)) { $grid.headers.string_2.hidden = false } else { $grid.headers.string_2.hidden = true }
      let string_3 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_3))?.map(r => r.entity.string_3); if ($utils.isDefined(string_3)) { $grid.headers.string_3.hidden = false } else { $grid.headers.string_3.hidden = true }
      let string_4 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_4))?.map(r => r.entity.string_4); if ($utils.isDefined(string_4)) { $grid.headers.string_4.hidden = false } else { $grid.headers.string_4.hidden = true }
      let string_5 = $grid.rows.filter(r => $utils.isDefined(r.entity.string_5))?.map(r => r.entity.string_5); if ($utils.isDefined(string_5)) { $grid.headers.string_5.hidden = false } else { $grid.headers.string_5.hidden = true }
  
  }
  
  let application_name: string = $grid.inParams.application_name ?? "";
  
  if (application_name.toUpperCase() === "NULL") {
      application_name = "";
  }
  
  let transaction_id: string = $grid.inParams.transaction_id ?? "";
  
  if (transaction_id.toUpperCase() === "NULL") {
      transaction_id = "";
  }
  
  if (application_name !== "" || transaction_id !== "") {
      $grid.headers.application_name.hidden = true;
  } else {
      $grid.headers.application_name.hidden = false;
  }
  
  if (($grid.totalCount ?? 0) <= 1000) {
      $grid.topToolbar.clean_log.hidden = true;
  } else {
      $grid.topToolbar.clean_log.hidden = false;
  }
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: Utilities_logs_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/19/2024
  
  const selected_rows = $grid.selectedRows;
  let errors: { id: string, errorMessages: string[] }[] = [];
  let deleted_records: string[] = [];
  
  if (selected_rows.length === 0) {
      $shell.Utilities.openErrorDialog('Delete error!', 'No records were selected!');
      return;
  } else {
  
      const confirm_purge = (await $shell.Utilities.openConfirmationDialog(`Confirm delete!`, `Do you want to delete ${selected_rows.length} records?`, `Delete`, `Cancel`));
  
      if (confirm_purge) {
  
          for (const row of selected_rows) {
  
              let current_error: string;
              let success = false;
              current_error = null;
  
              try {
  
                  let entity = row.entity
  
                  await $flows.Utilities.logs_delete({
                      input: [{ log_id: entity.log_id }],
                      criteria: { application_name: entity.application_name }
                  });
  
                  success = true;
  
              } catch (error) {
  
                  let target_error = error;
  
                  if (typeof target_error === "string") {
                      target_error = { message: target_error };
                  } else {
                      while ($utils.isDefined(target_error.error)) {
                          target_error = target_error.error;
                      };
                  };
  
                  if (!$utils.isDefined(target_error.message)) {
                      target_error = { message: `Uncaught exception! ${JSON.stringify(target_error)}` };
                  };
  
                  current_error = target_error.message;
              };
  
              if (success) {
                  deleted_records.push(row.entity.log_id.toString())
              } else {
                  errors.push({
                      id: row.entity.log_id, errorMessages: [current_error]
                  });
              };
          };
  
          if ($utils.isDefined(errors)) {
              await $shell.Utilities.openErrorDialog(
                  `Delete record${selected_rows.length > 1 ? 's' : ''}`,
                  deleted_records.length > 0 ? `Record${selected_rows.length > 1 ? 's' : ''} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: deleted_records })).formattedValue} successfully deleted.` : `No records were deleted.`,
                  null,
                  `Errors deleting record${selected_rows.length > 1 ? 's' : ''}`,
                  errors.map(error => ({ detail: error.errorMessages[0], message: `Id: ${error.id}` })))
          };
  
          if (deleted_records.length > 0) {
  
              await $flows.Utilities.logs_write({
                  input: [{
                      level: 1,
                      transaction_id: selected_rows[0].entity.transaction_id,
                      notes: `Deleted logs! Ids: ${JSON.stringify(deleted_records)} Notes: ${selected_rows[0].entity.notes}`
                  }],
                  criteria: { application_name: selected_rows[0].entity.application_name }
              });
          };
      };
  };
  
  $grid.refresh();
  }
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: Utilities_logs_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/22/2024
  
  if ($grid.rows.length > 0) {
  
      let ids: string[] = [];
  
      if ($utils.isDefined($grid.selectedRows)) {
          if ($grid.selectedRows.length > 0) {
              ids = $grid.selectedRows.map(o => o.entity.log_id);
          };
      };
  
      let full_text_search = $grid.fullTextSearch;
      let transaction_id = $grid.inParams.transaction_id;
      let level = $grid.filters.level.control.value;
      let process_name = $grid.filters.process.control.value;
      let application_name = $grid.inParams.application_name;
  
      let data = (await $datasources.Utilities.ds_logs_grid.getList({
          $skip: 0,
          $top: 1000,
          level: level,
          process_name: process_name,
          transaction_id: transaction_id,
          application_name: application_name,
          full_text_search: full_text_search,
          date_to: $grid.filters.date_to.control.value,
          date_from: $grid.filters.date_from.control.value,
          number_1: $grid.inParams.filter_values?.number_1,
          number_2: $grid.inParams.filter_values?.number_2,
          number_3: $grid.inParams.filter_values?.number_3,
          number_4: $grid.inParams.filter_values?.number_4,
          number_5: $grid.inParams.filter_values?.number_5,
          string_1: $grid.inParams.filter_values?.string_1,
          string_2: $grid.inParams.filter_values?.string_2,
          string_3: $grid.inParams.filter_values?.string_3,
          string_4: $grid.inParams.filter_values?.string_4,
          string_5: $grid.inParams.filter_values?.string_5
      }))
  
      if (data.totalCount > 0) {
  
          let log: any;
          let logs: any[] = [];
  
          let results = data.result;
  
          if (ids.length > 0) {
              results = results.filter(r => ids.indexOf(r.log_id) >= 0);
          };
  
          for (let result of results) {
              log = {
                  "Application": result.application_name,
                  "Process": result.process_name,
                  "Transaction": result.transaction_id,
                  "Level": result.level,
                  "Notes": result.notes,
                  "Message": result.message,
                  "Created by": result.created_by,
                  "Created on": result.created_on,
                  "Alerted on": result.alerted_on
              }
  
              if ($utils.isDefined(result.number_1)) { let name = "Number 1"; if ($utils.isDefined($grid.inParams.column_names?.number_1)) { name = $grid.inParams.column_names?.number_1 } log[name] = result.number_1 }
              if ($utils.isDefined(result.number_2)) { let name = "Number 2"; if ($utils.isDefined($grid.inParams.column_names?.number_2)) { name = $grid.inParams.column_names?.number_2 } log[name] = result.number_2 }
              if ($utils.isDefined(result.number_3)) { let name = "Number 3"; if ($utils.isDefined($grid.inParams.column_names?.number_3)) { name = $grid.inParams.column_names?.number_3 } log[name] = result.number_3 }
              if ($utils.isDefined(result.number_4)) { let name = "Number 4"; if ($utils.isDefined($grid.inParams.column_names?.number_4)) { name = $grid.inParams.column_names?.number_4 } log[name] = result.number_4 }
              if ($utils.isDefined(result.number_5)) { let name = "Number 5"; if ($utils.isDefined($grid.inParams.column_names?.number_5)) { name = $grid.inParams.column_names?.number_5 } log[name] = result.number_5 }
  
              if ($utils.isDefined(result.string_1)) { let name = "String 1"; if ($utils.isDefined($grid.inParams.column_names?.string_1)) { name = $grid.inParams.column_names?.string_1 } log[name] = result.string_1 }
              if ($utils.isDefined(result.string_2)) { let name = "String 2"; if ($utils.isDefined($grid.inParams.column_names?.string_2)) { name = $grid.inParams.column_names?.string_2 } log[name] = result.string_2 }
              if ($utils.isDefined(result.string_3)) { let name = "String 3"; if ($utils.isDefined($grid.inParams.column_names?.string_3)) { name = $grid.inParams.column_names?.string_3 } log[name] = result.string_3 }
              if ($utils.isDefined(result.string_4)) { let name = "String 4"; if ($utils.isDefined($grid.inParams.column_names?.string_4)) { name = $grid.inParams.column_names?.string_4 } log[name] = result.string_4 }
              if ($utils.isDefined(result.string_5)) { let name = "String 5"; if ($utils.isDefined($grid.inParams.column_names?.string_5)) { name = $grid.inParams.column_names?.string_5 } log[name] = result.string_5 }
  
              logs.push(log)
          }
  
          let wb = $event;
          let ws = $utils.excel.json_to_sheet(logs);
          $utils.excel.book_append_sheet(wb, ws, "Logs");
  
      } else {
          $shell.Utilities.openInfoDialog('Error', 'The parameters did not return any records to export.')
      };
  } else {
      $shell.Utilities.openInfoDialog('Error', 'There are no records to export!')
  };
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: Utilities_logs_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  const selectedRowsCount = $grid.selectedRows.length;
  
  $grid.topToolbar.delete_log.control.readOnly = (selectedRowsCount > 0 ? false : true);
  }
  on_clean_clicked(event = null) {
    return this.on_clean_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_clean_clickedInternal(
    $grid: Utilities_logs_gridComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_logs_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/24/2024
  
  let get_date = (await $flows.Utilities.logs_clean({ criteria: { application_name: $grid.inParams.application_name, confirm: false } }))
  
  if ($utils.isDefined(get_date?.date_to)) {
  
      let date_to = new Date(get_date?.date_to);
  
      const confirm_purge = (await $shell.Utilities.openConfirmationDialog(`Confirm clean!`, `This will attempt to purge aproximately ${get_date.count} records as of ${date_to.toLocaleDateString()}.`, `Proceed`, `Cancel`));
  
      if (confirm_purge) {
  
          await $flows.Utilities.logs_clean({ criteria: { application_name: $grid.inParams.application_name, date_to: get_date?.date_to, confirm: true } });
      }
  
  } else {
  
      let totalCount: number = $grid.totalCount ?? 0;
  
      if (totalCount <= 1000) {
          $shell.Utilities.openErrorDialog("Error!", `A clean-up is not required, as there are less than 1,000 records (${totalCount.toLocaleString()}).`)
      } else {
          $shell.Utilities.openErrorDialog("Error!", "Could not determine a date to start the clean-up!")
      }
  }
  
  $grid.refresh()
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'Utilities_logs_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
